/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { XrxControlBaseComponent } from './xrx-control-base.component';
import { OptionListOptions } from '../../services/workflow.service';

@Component({
  selector: 'xrx-select',
  templateUrl: './xrx-select.component.html',
  styleUrls: ['./xrx-select.component.less'],
  host: {
    '(document:submit)': 'onSubmit($event)',
  },
  providers: [
    { provide: XrxControlBaseComponent, useExisting: XrxSelectComponent },
  ],
  standalone: false,
})
export class XrxSelectComponent<T>
  extends XrxControlBaseComponent
  implements OnInit
{
  @Input() id = '';
  @Input() label: string;
  @Input() inlineLabel: string;
  @Input() list: T[] = [];
  @Input() selectedItem: T | null;
  @Input() property: string;
  @Input() localize: string;
  @Input() type: string;
  @Input() error: string;
  @Input() orderby: string;
  @Input() dir = 'asc';
  @Input() sort = true;
  @Input() required: boolean;
  @Input() isMfd: boolean;
  @Input() isInputOnly: boolean;
  @Input() placement: string;

  @Output() selectedItemChange = new EventEmitter<any>();
  @Output() change = new EventEmitter<any>();
  @Output() validation = new EventEmitter<boolean>();
  @Output() listChange = new EventEmitter<T[]>();

  isSubmitted = false;
  dropdownMinWidth = '';

  ngOnInit() {
    if (this.isInputOnly) {
      this.dropdownMinWidth = '98%';
    } else {
      this.dropdownMinWidth = '100%';
    }
    if (!this.placement) {
      // dropdown menu placements to try: bottom is dropdown, top is dropup
      this.placement = 'bottom-left, bottom-right, top-left, top-right';
    }
  }

  selectItem(item: T) {
    this.selectedItem = item;
    this.selectedItemChange.emit(this.selectedItem);
    this.change.emit(this.selectedItem);
    this.validate();
  }

  isErrorState() {
    return (
      !this.selectedItem && ((this.required && this.isSubmitted) || this.error)
    );
  }

  onSubmit($event: Event) {
    this.isSubmitted = true;
  }

  validate() {
    this.validation.emit(this.required && !this.selectedItem ? false : true);
  }

  getPropertyString(type: 'localize' | 'property', item?: T): string {
    if (item) {
      if (type === 'localize') {
        const propertyString = item[this.localize as keyof typeof item];
        return propertyString as string;
      } else if (type === 'property') {
        const propertyString = item[this.property as keyof typeof item];
        return propertyString as string;
      }
    } else if (type === 'localize') {
      const propertyString =
        this.selectedItem?.[this.localize as keyof typeof this.selectedItem];
      return propertyString as string;
    } else if (type === 'property') {
      const propertyString =
        this.selectedItem?.[this.property as keyof typeof this.selectedItem];
      return propertyString as string;
    }
    return '';
  }
}
